import { useGqlMutation, useGqlQuery } from '@API/useAvQuery';
import { QueryKey } from '@fabric-ui/utils';
import { gql } from 'graphql-request';
import { useAvContext } from '../../../context/AvContextProvider';
import { AnyDefaultAutomationType, AutomationTypesEnum, IAutomationType, SupportedAutomationsProjNames, SystemSyncSetting } from './types';

export const useGetAutomationRules = ({
  projectionName,
  onSuccess,
}: {
  projectionName: string;
  onSuccess: (data: IAutomationType[]) => void;
}) =>
  useGqlQuery<IAutomationType[]>({
    queryKey: [QueryKey.GetAutomationRules, projectionName],
    query: GET_AUTOMATION_RULES,
    variables: { category: 'LIFECYCLE', projectionName },
    onSuccess,
  });

export const useDeleteAutomation = (onSuccess: (data: any) => void = () => {}) =>
  useGqlMutation<any, { automationId: string }>({
    mutationKey: [QueryKey.DeleteAutomation],
    mutation: DELETE_AUTOMATION,
    onSuccess,
  });

export const useGetAutomationRulesDefaults = ({ projectionName, enabled }) =>
  useGqlQuery<AnyDefaultAutomationType[]>({
    queryKey: [QueryKey.GetAutomationRulesDefaults, projectionName],
    query: GET_AUTOMATION_RULES_DEFAULTS,
    variables: { category: 'LIFECYCLE', projectionName },
    enabled,
  });

export const useGetAutomationSyncStatus = ({ projectionName }) =>
  useGqlQuery<SystemSyncSetting[]>({
    queryKey: [QueryKey.GetAutomationSyncStatus],
    query: GET_AUTOMATION_SYNC_STATUS,
    variables: { projectionName },
    gcTime: 0,
  });

export const GET_AUTOMATION_SYNC_STATUS = gql`
  query getAutomationsSyncStatus($projectionName: String!) {
    getAutomationsSyncStatus(projectionName: $projectionName) {
      automationType
      automationSyncStatusDto {
        synced
        settingsType
        relatedTypes
      }
    }
  }
`;
export const GET_AUTOMATION_RULES = gql`
  query getAutomationsForCategoryAndProjection($category: AutomationCategory!, $projectionName: String!) {
    getAutomationsForCategoryAndProjection(category: $category, projectionName: $projectionName) {
      id
      automationType
      projectionName
      automationRules {
        id
        name
        ruleOrder
        config
      }
      fallbackAutomationRules {
        id
        name
        ruleOrder
        config
      }
    }
  }
`;

export const GET_AUTOMATION_RULES_DEFAULTS = gql`
  query getAutomationRuleConfigsDefaults($category: AutomationCategory!, $projectionName: String!) {
    getAutomationRuleConfigsDefaults(category: $category, projectionName: $projectionName) {
      automationType
      configs
    }
  }
`;

export const CREATE_OR_UPDATE_AUTOMATION = gql`
  mutation createOrUpdateAutomation($automationDto: AutomationDtoInput!) {
    createOrUpdateAutomation(automationDto: $automationDto)
  }
`;

export const DELETE_AUTOMATION = gql`
  mutation deleteAutomation($automationId: String!) {
    deleteAutomation(automationId: $automationId)
  }
`;

export const useGetAutomationField = ({ projName }: { projName: SupportedAutomationsProjNames }) => {
  const {
    accountEntities: { aggProjs },
  } = useAvContext();
  const { projDisplayName } = aggProjs[projName];

  return {
    [AutomationTypesEnum.ENTITY_LOCKED]: {
      title: `New ${projDisplayName} Creation Triggers`,
    },
  };
};
